import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "src", "size", "highlight", "highlightWidth", "className", "href"];
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { AvatarFallbackIcon } from '../AvatarFallbackIcon';
import { isCompanyAvatarType } from '../../helpers';
import * as styles from './styles.module.css';
import { colorToValue } from '../../../../internal/utils/colorToValue';
import { OptionalAnchor } from '../../../../internal/components/OptionalAnchor';
/**
 * Компонент аватарки
 *
 * Люди - круглые
 * Компании - квадратные
 */
export var InternalAvatar = /*#__PURE__*/React.forwardRef(function InternalAvatar(_ref, ref) {
  var type = _ref.type,
    src = _ref.src,
    size = _ref.size,
    highlight = _ref.highlight,
    highlightWidth = _ref.highlightWidth,
    className = _ref.className,
    href = _ref.href,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    errorSrc = _React$useState2[0],
    setErrorSrc = _React$useState2[1];
  var isFallback = !src || errorSrc === src;
  var isCompany = isCompanyAvatarType(type);
  var isClickable = !!(href || rest.onClick);
  var handleError = function handleError() {
    setErrorSrc(src || null);
  };
  return /*#__PURE__*/React.createElement(OptionalAnchor, _extends({}, rest, {
    ref: ref,
    className: cx(className, styles['avatar'], isCompany && styles['company'], isClickable && styles['clickable']),
    style: {
      width: size,
      height: size,
      boxShadow: highlight ? "0 0 0 ".concat(highlightWidth, "px ").concat(colorToValue(highlight)) : undefined
    },
    href: href
  }), isFallback && /*#__PURE__*/React.createElement(AvatarFallbackIcon, {
    type: type
  }), !isFallback && /*#__PURE__*/React.createElement("img", {
    src: src,
    onError: handleError,
    decoding: "async"
  }));
});